// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {FormHelperText, Input, InputLabel, Select, Stack, TextField} from "@mui/material";

// App Imports
import {
    addContractSectionFilter,
    editContractSectionFilter, getContractSectionCSF,
    updateSectionFilterHierarchy
} from "./ContractSectionFilterClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import {changeContractSectionFilter} from "./contractSectionFilterSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {getAllDataPoints} from "../DataPoint/DataPointClient";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {Autocomplete} from "@mui/lab";
import DynamicCdpvValueField from "../CommonComponents/DynamicCdpvValueField";
import dayjs from "dayjs";


// Main Function
export default function ContractSectionFilterDrawer({contractSectionFilterDrawerState,contractSectionFilterDrawerMode,fetchContractSectionFilters}) {


    // ****************** BEGIN STATES ****************************

    const [showContractSectionFilterDrawer, setShowContractSectionFilterDrawer] = React.useState(false);
    const [submitting, setSubmitting] = useState(true);
    const [showPreviousMenu, setShowPreviousMenu] = React.useState(true);
    const [filteredData, setFilteredData] = React.useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorContractSectionFilterId = useSelector((state) => state.contractSectionFilterSlc.value.id);
    // const selectorCsfDrawerState = useSelector((state) => state.contractSectionFilterSlc.value.csfDrawerState);
    // const selectorCsfDrawerMode = useSelector((state) => state.contractSectionFilterSlc.value.csfDrawerMode);
    const selectorCsfDrawerState = useSelector((state) => state.contractSectionFilterSlc.value.csfDrawerState);
    const selectorCsfDrawerMode = useSelector((state) => state.contractSectionFilterSlc.value.csfDrawerMode);
    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);
    const selectorDataType = useSelector((state) => state.contractSectionFilterSlc.value.dataType);
    const selectorAccessType = useSelector((state) => state.contractSectionFilterSlc.value.accessType);
    const selectorFilteringMethod = useSelector((state) => state.contractSectionFilterSlc.value.filteringMethod);
    const selectorDataPointValueId = useSelector((state) => state.contractSectionFilterSlc.value.singleValue);
    const selectorSingleValue = useSelector((state) => state.contractSectionFilterSlc.value.singleValue);
    const selectorDataPointId = useSelector((state) => state.contractSectionFilterSlc.value.dataPointId);
    const selectorFromValue = useSelector((state) => state.contractSectionFilterSlc.value.fromValue);
    const selectorToValue = useSelector((state) => state.contractSectionFilterSlc.value.toValue);
    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    // const {register, handleSubmit} = useForm();
    const { register, handleSubmit,setValue,  control, formState: { errors } } = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my original form data")
        console.log({data})
        console.log("here's my new stringify data")
        //https://melvingeorge.me/blog/hide-remove-omit-certain-values-keys-from-json-stringify-output-javascript
        console.log(JSON.stringify(data, (key, value) => {
            // Check if key matches the string "pin" or "mob"
            // if matched return value "undefined"
            if (key === "parentFilterId" || key === "previousFilterId" ) {
                return undefined;
            }

            // else return the value itself
            return value;
        }))
        console.log("here's my parsed data")
        //https://melvingeorge.me/blog/hide-remove-omit-certain-values-keys-from-json-stringify-output-javascript
        console.log(JSON.parse(JSON.stringify(data, (key, value) => {
            // Check if key matches the string "pin" or "mob"
            // if matched return value "undefined"
            if (key === "parentFilterId" || key === "previousFilterId" ) {
                return undefined;
            }
            // else return the value itself
            return value;
        })))
        setFilteredData(JSON.parse(JSON.stringify(data, (key, value) => {
            // Check if key matches the string "pin" or "mob"
            // if matched return value "undefined"
            if (key === "parentFilterId" || key === "previousFilterId" ) {
                return undefined;
            }

            // else return the value itself
            return value;
        })))
        if((selectorCsfDrawerMode==="Add") && ((data.parentFilterId !== '' ) && (data.parentFilterId !== null ))  && ((data.previousFilterId === '' ) || (data.previousFilterId === null ))){
            addContractSectionFilter(
                JSON.parse(JSON.stringify(data, (key, value) => {
                    if (key === "previousFilterId" ) {
                        return undefined;}
                    return value;
                })))
                .then(() => {
                    return updateSectionFilterHierarchy(selectorContractSectionId);
                })
                .then(() => {
                    // updateSectionFilterHierarchy(selectorContractSectionId);
                    console.log("ContractSectionFilter added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                    // fetchContractSectionFilters();
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("selectorContractSectionId")
                console.log(selectorContractSectionId);
                // updateSectionFilterHierarchy(selectorContractSectionId);
                // setShowContractSectionFilterDrawer(false);

                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added",csfDrawerState: false}));
                dispatchData(changeContractSectionFilter({id: 0, contractSectionId:null, parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,accessType:false,
                    filteringMethod: null, dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    csfDrawerState: false, csfGridRefresh: true}));
            })}
        if((selectorCsfDrawerMode==="Add") && ((data.parentFilterId === '' ) || (data.parentFilterId === null ))  && ((data.previousFilterId !== '' ) && (data.previousFilterId !== null ))){
            addContractSectionFilter(
                JSON.parse(JSON.stringify(data, (key, value) => {
                if (key === "parentFilterId") {
                    return undefined;}
                return value;
            })))
                .then(() => {
                    return updateSectionFilterHierarchy(selectorContractSectionId);
                })
                .then(() => {
                    // updateSectionFilterHierarchy(selectorContractSectionId);
                    console.log("ContractSectionFilter added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("selectorContractSectionId")
                console.log(selectorContractSectionId);
                // updateSectionFilterHierarchy(selectorContractSectionId);
                dispatchData(changeContractSectionFilter({id: 0, contractSectionId:null, parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,accessType:false,
                    filteringMethod: null, dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    csfDrawerState: false, csfGridRefresh: true}));
            })}
        if((selectorCsfDrawerMode==="Add") && ((data.parentFilterId === '' ) || (data.parentFilterId === null ))  && ((data.previousFilterId === '' ) || (data.previousFilterId === null ))){
            addContractSectionFilter(
                JSON.parse(JSON.stringify(data, (key, value) => {
                    if ( key === "parentFilterId"  || key === "previousFilterId"  ) {
                        return undefined;}
                    return value;
                })))
                .then(() => {
                    return updateSectionFilterHierarchy(selectorContractSectionId);
                })
                .then(() => {
                    // updateSectionFilterHierarchy(selectorContractSectionId);
                    console.log("ContractSectionFilter added without parent or previous");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("selectorContractSectionId")
                console.log(selectorContractSectionId);
                // updateSectionFilterHierarchy(selectorContractSectionId);
                dispatchData(changeContractSectionFilter({id: 0, contractSectionId:null, parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,accessType:false,
                    filteringMethod: null, dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    csfDrawerState: false, csfGridRefresh: true}));
            })}

        if((selectorCsfDrawerMode==="Add") && ((data.parentFilterId !== '' ) && (data.parentFilterId !== null ))  && ((data.previousFilterId !== '' ) && (data.previousFilterId !== null ))){
            addContractSectionFilter(data)
                .then(() => {
                    return updateSectionFilterHierarchy(selectorContractSectionId);
                })
                .then(() => {
                    // updateSectionFilterHierarchy(selectorContractSectionId);
                    console.log("ContractSectionFilter added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("selectorContractSectionId")
                console.log(selectorContractSectionId);
                // updateSectionFilterHierarchy(selectorContractSectionId);
                dispatchData(changeContractSectionFilter({id: 0, contractSectionId:null, parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,accessType:false,
                    filteringMethod: null, dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    csfDrawerState: false, csfGridRefresh: true}));
            })}
        if(selectorCsfDrawerMode==="Edit"){
            console.log("This is the contractSectionFilter Id I am going to edit")
            console.log(selectorContractSectionFilterId)
            console.log("This is my data")
            console.log(data)
            editContractSectionFilter(selectorContractSectionFilterId, data)
                .then(() => {
                    return updateSectionFilterHierarchy(selectorContractSectionId);
                })
                .then(() => {
                    console.log("ContractSectionFilter edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                    // fetchContractSectionFilters();
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
                // updateSectionFilterHierarchy(selectorContractSectionId);
            }).finally(() =>{
                // updateSectionFilterHierarchy(selectorContractSectionId);
                setSubmitting(false);
                // setShowContractSectionFilterDrawer(false);
                dispatchData(changeContractSectionFilter({id: 0, contractSectionId:null, parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,accessType:false,
                    filteringMethod: null, dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                csfDrawerState: false, csfGridRefresh: true}));
            })}
    };

    // ****************** END CRUD ****************************


    useEffect(() => {
        let formattedSingleValue = selectorSingleValue;

        if (selectorDataType === 'DATE') {
            if (selectorSingleValue && selectorSingleValue.format) {
                formattedSingleValue = dayjs(selectorSingleValue).format('MM/DD/YYYY');
            } else if (selectorSingleValue instanceof Date) {
                formattedSingleValue = selectorSingleValue.toLocaleDateString();
            } else if (!selectorSingleValue) {
                formattedSingleValue = '';
            }
        }

        setValue('singleValue', formattedSingleValue);
    }, [selectorSingleValue, selectorDataType, setValue]);

    useEffect(() => {
        let formattedFromValue = selectorFromValue;

        if (selectorDataType === 'DATE') {
            if (selectorFromValue && selectorFromValue.format) {
                formattedFromValue = dayjs(selectorFromValue).format('MM/DD/YYYY');
            } else if (selectorFromValue instanceof Date) {
                formattedFromValue = selectorFromValue.toLocaleDateString();
            } else if (!selectorFromValue) {
                formattedFromValue = '';
            }
        }

        setValue('fromValue', formattedFromValue);
    }, [selectorFromValue, selectorDataType, setValue]);


    useEffect(() => {
        let formattedToValue = selectorToValue;

        if (selectorDataType === 'DATE') {
            if (selectorToValue && selectorToValue.format) {
                formattedToValue = dayjs(selectorToValue).format('MM/DD/YYYY');
            } else if (selectorToValue instanceof Date) {
                formattedToValue = selectorToValue.toLocaleDateString();
            } else if (!selectorToValue) {
                formattedToValue = '';
            }
        }

        setValue('toValue', formattedToValue);
    }, [selectorToValue, selectorDataType, setValue]);



    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    function closeContractSectionFilterDrawer() {
        // setShowContractSectionFilterDrawer(false);
        dispatchData(changeContractSectionFilter({
            csfDrawerState: false}));
    };

    // ****************** END MISC ****************************

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);
    const [selectedDataPointValue, setSelectedDataPointValue] = useState([useSelector((state) => state.contractSectionFilterSlc.value.singleValue)]);
    const [selectedDataPointRow, setSelectedDataPointRow] = useState(null);
    const [selectedDataType, setSelectedDataType] = useState( [useSelector((state) => state.contractSectionFilterSlc.value.dataType)]);
    const [listDataPointValues, setListDataPointValues] = useState(null);
    let selDataType = null;
    let selDataPointRow = null;
    // let listDataPointValues = null;



    const fetchDataPoints = () =>
        getAllDataPoints()

            .then(data => {
                console.log(data);
                setDataPoints(data);
            })
    useEffect(() => {
        fetchDataPoints();
    }, []);

    const loadEditList = (dataPointEvent) => {
        if(selectorCsfDrawerMode==="Edit"){
        console.log("selectorDataPointId ", selectorDataPointId);
        getAllDataPointValues()

        .then(data => {
            console.log(data);
            setListDataPointValues(data.filter(data => data.dataPointId ===  selectorDataPointId));
            selDataType = selectorDataType;
            setSelectedDataType (selectorDataType);
            console.log("This is the edit data point's data type");
            console.log(selDataType);
            // console.log(dataPointEvent.target.dataType);
            console.log("This is the selected data type raw");
            console.log(selDataPointRow);
        })
    }
}
    useEffect(() => {
        loadEditList();
    }, []);

    const handleDataPointChange = (dataPointEvent) => {
        setSelectedDataPoint(dataPointEvent);
        dispatchData(changeContractSectionFilter({dataPointId: dataPointEvent ? dataPointEvent.id : 0, dataType: dataPointEvent ?  dataPointEvent.dataType : ""
            ,
        singleValue: null, fromValue: null, toValue: null}));
        console.log("This is the selected data point's data");
        console.log(dataPointEvent);
        // setSelectedDataPointRow(dataPointEvent ? dataPoints.filter(dataPoints => dataPoints.id ===  dataPointEvent.id) : 0);
        // // selDataPointRow = dataPoints.filter(dataPoints => dataPoints.id ===  dataPointEvent.id);
        // selDataPointRow = dataPointEvent ? dataPoints.filter(dataPoints => dataPoints.id ===  dataPointEvent.id) : 0;

        // const handleDataPointChange = (dataPointEvent) => {
        //     console.log("handleDataPointChange triggered by ", dataPointEvent);
        //     // setSelectedDataPoint(dataPointEvent);
        //     dispatchData(changeContractSectionFilter({dataPointId: dataPointEvent}));
        //     console.log("This is for the selected Value");
        //     console.log(dataPointEvent);
        // };




        // selDataType = selDataPointRow[1];
    //     getAllDataPointValues()

    //         .then(data => {
    //             console.log(data);
    //             setListDataPointValues(data.filter(data => data.dataPointId ===  dataPointEvent));
    //     selDataType = selDataPointRow.map(function (item){return item.dataType});
    //     setSelectedDataType (selDataPointRow.map(function (item){return item.dataType}).toString());
    //     console.log("This is the selected data type");
    //     console.log(selDataType);
    //     console.log("This is the selected data type raw");
    //     console.log(selDataPointRow);
    // })

    };
    //
    // const handleDataPointValueChange = (event2) => {
    //     setSelectedDataPointValue(event2.target.value);
    //     dispatchData(changeContractSectionFilter({singleValue: event2.target.value}));
    //     console.log("This is for the selected Data Point Value");
    //     console.log(event2);
    // };

    //
    // const handleDataPointValueChange = (event2) => {
    //     setSelectedDataPointValue(event2.target.value);
    //     console.log("This is for the selected Data Point Value");
    //     console.log(event2.target.value);
    // };

    // this sets the setValue to the dp id that is loaded when editing
    useEffect(() => {
        const existingValue = selectorDataPointId;
        setValue('dataPoint.id', existingValue ? existingValue : null);
    }, [selectorDataPointId, setValue]);



    // ******************* BEGIN ACCESS and METHOD *********************

    const [access, setAccess] = useState([]);
    const [method, setMethod] = useState([]);
    const [selectedAccess, setSelectedAccess] = useState([useSelector((state) => state.contractSectionFilterSlc.value.accessType)]);
    const [selectedMethod, setSelectedMethod] = useState([useSelector((state) => state.contractSectionFilterSlc.value.filteringMethod)]);



    const fetchDataPointValues = () =>
        getAllDataPointValues()

            .then(data => {
                console.log(data);
                setAccess(data.filter(data => data.dataPointId ===  2336));
                setMethod(data.filter(data => data.dataPointId ===  2335));
            })
    useEffect(() => {
        fetchDataPointValues();
    }, []);
    //
    const handleAccessChange = (accessEvent) => {
        setSelectedAccess(accessEvent.target.value);
        console.log("This is for the selected access");
        console.log(accessEvent.target.value);
    };

    const handleMethodChange = (methodEvent) => {
        setSelectedMethod(methodEvent.target.value);
        console.log("This is for the selected method");
        console.log(methodEvent.target.value);
    };

// end access and method dropdowns

    // *********************** BEGIN DROPDOWNS **************************

    const selectedCdpDp = useSelector((state) => state.contractSectionSlc.value.dataPointId);
    const [parentDropdown, setparentDropdown] = useState([]);
    const [selectedParent, setSelectedParent] = useState([useSelector((state) => state.contractSectionFilterSlc.value.parentFilterId)]);
    let parentFilter = 0;

    const [previousDropdown, setPreviousDropdown] = useState([]);
    const [selectedPrevious, setSelectedPrevious] = useState([useSelector((state) => state.contractSectionFilterSlc.value.previousFilterId)]);

    const fetchContractSectionFiltersForParent = () =>
        getContractSectionCSF(selectorContractSectionId)

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );

                setparentDropdown(data);
            })
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchContractSectionFiltersForParent();
    }, []);


    const fetchContractSectionFiltersForPrevious = () =>
        getContractSectionCSF(selectorContractSectionId)

            .then(data => {
                console.log(data);
                if((parentFilter === 0)){setPreviousDropdown(data.filter(data => data.parentFilterId ===  null));}
                else{
                setPreviousDropdown(data.filter(data => data.parentFilterId ===  parentFilter));}

            })
            .then(() => console.log("selectedParent"))
            .then(() => console.log({selectedParent}))
            .then(() => console.log("parentFilter"))
            .then(() => console.log({parentFilter}))
            .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})
            .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})
    useEffect(() => {
        console.log("This is for the dropdown csf...");
        fetchContractSectionFiltersForPrevious();
    }, [parentFilter === 0]);


    const handleParentChange = (parentEvent) => {
        parentFilter = parentEvent.target.value;
        setSelectedParent(parentEvent.target.value);
        console.log("This is for the selected Parent Filter");
        console.log(parentEvent.target.value)
        fetchContractSectionFiltersForPrevious()

    };

    const handlePreviousChange = (previousEvent) => {
        setSelectedPrevious(previousEvent.target.value);
        console.log("This is for the selected Previous Filter");
        console.log(previousEvent.target.value);
    };

// *********************** END DROPDOWNS **************************



    // ****************** BEGIN FORM ****************************

    function contractSectionFilterForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{ width: 700 , height: 300, pl: 5}}
                    role="presentation"

                >
                    {selectorContractGridAPI !== "Dashboards" && <h2                         style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeContractSectionFilterDrawer()}>Contract Section Filter Form</h2>}
                    {selectorContractGridAPI === "Dashboards" && <h2                         style={ { paddingLeft: 0,
                        cursor:'pointer'}} onClick={() => closeContractSectionFilterDrawer()}>Filtering Criteria Form</h2>}
                    <h4>{selectorCsfDrawerMode} Mode</h4>


                    <Input  style={{ visibility: "hidden" }}
                        {...register('contractSection.id',  {required: true })}
                        // type="number"
                        id="contractSection.id" name="contractSection.id"  label="contractSectionId" aria-describedby="contractSectionId_entry"
                        defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.contractSectionId)}
                        sx={{ width: 500 }}/>

                    {selectorCsfDrawerMode !== "Edit" &&
                    <br />}
                    {selectorCsfDrawerMode !== "Edit" &&
                        <br />}
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 500 }}
                                 style={{ visibility: selectorCsfDrawerMode === "Edit" ? "hidden" : "visible"}}>
                        <InputLabel htmlFor="parentFilterId">Parent Filter</InputLabel>
                        <Select
                            {...register('parentFilterId', { required: false })}
                            labelId="demo-simple-select-filled-parent"
                            id="parentFilterId"
                            value={selectedParent}

                            label="Parent Filter"
                            onChange={handleParentChange}
                            defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.parentFilterId)}
                        >
                            {parentDropdown.map((parentItem) =>
                                <MenuItem value={parentItem.id}>{parentItem.accessType} {parentItem.filteringMethod} {parentItem.dataPointName} {parentItem.mockValue}{parentItem.fromValue} {parentItem.toValue}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="value_helper">select the parent filter this will go under (if any) - this is an "and also this..." condition</FormHelperText>
                    </FormControl>

                    {selectorCsfDrawerMode !== "Edit" &&
                        <br />}
                    <Input style={{ visibility: "hidden" }}
                        {...register('ordinalNumber', { required: false })}
                        id="ordinalNumber" name="ordinalNumber"  label="Order" aria-describedby="ordinalNumber_entry"
                        defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.ordinalNumber)}
                    />
                    <Input style={{ visibility: "hidden" }}
                        {...register('recordLevel', { required: false })}
                        id="recordLevel" name="recordLevel"  label="Level" aria-describedby="recordLevel_entry"
                        defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.recordLevel)}
                    />
                    <Stack direction="row" spacing={1}>
                        <div>
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
                        <InputLabel htmlFor="accessType">Access Type</InputLabel>
                        <Select

                            {...register('accessType', { required: true })}
                            labelId="accessType"
                            id="accessType"
                            value={selectedAccess}
                            label="accessType"
                            onChange={handleAccessChange}
                            defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.accessType)}
                        >
                            {access.map((access) =>
                                <MenuItem value={access.name}>{access.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="access_helper">If true, will access to this section be allowed or denied?</FormHelperText>
                    </FormControl>
                        </div>

                        <div>
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
                        <InputLabel htmlFor="filteringMethod">Filtering Method</InputLabel>
                        <Select

                            {...register('filteringMethod', { required: true })}
                            labelId="filteringMethod"
                            id="filteringMethod"
                            value={selectedMethod}
                            label="filteringMethod"
                            onChange={handleMethodChange}
                            defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.filteringMethod)}
                        >
                            {method.map((method) =>
                                <MenuItem value={method.name}>{method.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="method_helper">Is the condition required to be true or to be not true?</FormHelperText>
                    </FormControl>
                        </div>
                    </Stack>
                    <br/>
                    {/*<FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>*/}
                    {/*    <InputLabel htmlFor="dataPoint.id">Data Point</InputLabel>*/}
                    {/*    <Select*/}

                    {/*        {...register('dataPoint.id', { required: true })}*/}
                    {/*        labelId="dataPoint.id"*/}
                    {/*        id="dataPoint.id"*/}
                    {/*        label="dataPoint.id"*/}
                    {/*        onChange={handleDataPointChange}*/}
                    {/*        defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.dataPointId)}*/}

                    {/*    >*/}
                    {/*        {dataPoints.map((DataPointItem) =>*/}
                    {/*            <MenuItem value={DataPointItem.id}>{DataPointItem.name}</MenuItem>*/}
                    {/*        )}*/}
                    {/*    </Select>*/}
                    {/*</FormControl>*/}
                    <Autocomplete
                        disablePortal
                        disableCloseOnBlur
                        ListboxProps={{
                            style: {
                                maxHeight: 400,  // <-- make the listbox longer
                            },
                            onClick: (event) => {
                                event.stopPropagation();
                            }
                        }}

                        labelId="dataPoint.id"
                        id="dataPointId"
                        options={dataPoints}
                        // getOptionLabel={(option) => option.name}
                        // getOptionLabel={(option) => option && option.name ? option.name : ""}
                        getOptionLabel={(option) => {
                            if (!option) return "";
                            if (typeof option === 'number' || typeof option === 'string') {
                                const found = dataPoints.find(dp => dp.id === parseInt(option));
                                return found && found.name ? found.name : "";
                            }
                            return option && option.name ? option.name : "";
                        }}
                        filterOptions={(options, state) => {
                            return options.filter(option => {
                                const name = option && option.name ? option.name : "";
                                return name.toLowerCase().includes(state.inputValue.toLowerCase());
                            });
                        }}
                        isOptionEqualToValue={(option, value) => option && value ? option.id === value.id : option === value}
                        // isOptionEqualToValue={(option, value) => option && value ? option.id === '999999' : option === value}
                        // isOptionEqualToValue={() => false}
                        // isOptionEqualToValue={(option, value) => option.id === value.id}
                        // isOptionEqualToValue={(option, value) =>
                        //     option && value ? option.id === value.id : option === value}
                        // defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.dataPointId)}
                        // value={dataPoints.find(dp => dp.id === parseInt(selectorContractDataPointId))}
                        // value={selectorDataPointId || null}
                        value={dataPoints.find(dp => dp.id === parseInt(selectorDataPointId)) || null}
                        onChange={(event, newValue) => {
                            setSelectedDataPoint(newValue);
                            setValue('dataPoint.id', newValue ? newValue.id : null, { shouldValidate: true });
                            console.log("onChange triggered in Data Point dropddown");
                            // handleDataPointChange(newValue ? newValue.id : null);
                            handleDataPointChange(newValue ? newValue : null);
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                            console.log("onInputChange triggered", newInputValue, reason);
                        }}
                        onHighlightChange={(event, option, reason) => {
                            console.log("onHighlightChange triggered", option, reason);
                        }}
                        sx={{width: 600}}
                        renderInput={(params) => <TextField {...params} label="Data Point" variant="standard"/>}
                        // ListboxComponent={ListboxComponent}
                    />
                    <FormHelperText id="DataPoint_helper">select the Data Point</FormHelperText>
                    <br/>

                    <br/>
                    {/*{*/}
                    {/*    ((selectedDataType === 'CODE' ||*/}
                    {/*        selectedDataType === 'YES_NO' ||*/}
                    {/*        selectedDataType === 'REFERENCE' ||*/}
                    {/*        selectorDataType === 'CODE' ) &&*/}
                    {/*        (listDataPointValues !== null &&*/}
                    {/*            listDataPointValues !== undefined ) )&&*/}
                    {/*    <div>*/}
                    {/*    <FormControl variant="standard"*/}
                    {/*                 sx={{ width: 300 }}*/}
                    {/*    >*/}
                    {/*        <InputLabel id="demo-simple-select-label2">Value</InputLabel>*/}

                    {/*        <Select*/}
                    {/*            {...register('singleValue', { required: false })}*/}
                    {/*            labelId="demo-simple-select-filled-label2"*/}
                    {/*            id="singleValue"*/}
                    {/*            value={selectedDataPointValue}*/}
                    {/*            label="Data Point Value"*/}
                    {/*            onChange={handleDataPointValueChange}*/}
                    {/*       //     defaultValue=        "28"*/}
                    {/*        >*/}

                    {/*            {listDataPointValues.map((singleDataPointValue) =>*/}
                    {/*                <MenuItem value={singleDataPointValue.id}>{singleDataPointValue.name}</MenuItem>*/}
                    {/*            )}*/}
                    {/*        </Select>*/}
                    {/*        <FormHelperText id="Value_helper">blank if just the data point being there is enough</FormHelperText>*/}
                    {/*    </FormControl>*/}
                    {/*    <br/>*/}
                    {/*    <br/>*/}
                    {/*    <Button*/}
                    {/*    type= "submit"*/}
                    {/*    >Submit</Button>*/}
                    {/*    <Button onClick={() => closeContractSectionFilterDrawer()}>Cancel</Button>*/}
                    {/*    </div>*/}
                    {/*}*/}

                    {/*{*/}
                    {/*    (selectedDataType !== 'CODE' &&*/}
                    {/*        selectedDataType !== 'YES_NO' &&*/}
                    {/*        selectedDataType !== 'REFERENCE' &&*/}
                    {/*        selectedDataType !== '' &&*/}
                    {/*        selectedDataType !== null &&*/}
                    {/*        selectedDataType !== undefined*/}
                    {/*        && (selectorCsfDrawerMode === 'Edit' ||*/}
                    {/*            (selectedDataPoint !== null &&*/}
                    {/*        selectedDataPoint !== undefined &&*/}
                    {/*    selectedDataPoint !== ''))*/}
                    {/*    ) &&*/}
                    {/*    <div>*/}
                    {/*        <FormHelperText id="Value_helper">leave this section blank if just the data point being there is enough</FormHelperText>*/}
                    {/*    <FormControl*/}

                    {/*        sx={{ width: 200 }}*/}
                    {/*    >*/}
                    {/*        <InputLabel  htmlFor="singleValue">Value</InputLabel>*/}
                    {/*        <Input*/}
                    {/*            {...register('singleValue', { required: false })}*/}
                    {/*            id="singleValue" name="singleValue"  label="Single Value" aria-describedby="singleValue_entry"*/}

                    {/*            defaultValue=        {selectorSingleValue}*/}
                    {/*        />*/}
                    {/*        <FormHelperText id="SingleValue_helper">exact match</FormHelperText>*/}
                    {/*    </FormControl>*/}

                    {/*<br/>*/}
                    {/*        <br/>*/}
                    {/*        <FormHelperText id="Value_helper">- or -</FormHelperText>*/}

                    {/*<br/>*/}
                    {/*<Stack direction="row" spacing={4}>*/}
                    {/*    <div>*/}
                    {/*<InputLabel  htmlFor="fromValue">From Value</InputLabel>*/}
                    {/*<Input*/}
                    {/*    {...register('fromValue', { required: false })}*/}
                    {/*    id="fromValue" name="fromValue"  label="From Value" aria-describedby="fromValue_entry"*/}
                    {/*    defaultValue=        {selectorFromValue}*/}
                    {/*/>*/}
                    {/*<FormHelperText id="fromValue_helper">lower limit of a range</FormHelperText>*/}
                    {/*    </div>*/}
                    {/*    <div>*/}
                    {/*<InputLabel  htmlFor="toValue">To Value</InputLabel>*/}
                    {/*<Input*/}
                    {/*    {...register('toValue', { required: false })}*/}
                    {/*    id="toValue" name="toValue"  label="To Value" aria-describedby="toValue_entry"*/}
                    {/*    defaultValue=        {selectorToValue}*/}
                    {/*/>*/}
                    {/*<FormHelperText id="toValue_helper">upper limit of a range</FormHelperText>*/}
                    {/*    </div>*/}
                    {/*</Stack>*/}
                    {/*        <br/>*/}
                    {/*        <br/>*/}
                    {/*        <Button*/}
                    {/*            type= "submit"*/}
                    {/*        >Submit</Button>*/}
                    {/*        <Button onClick={() => closeContractSectionFilterDrawer()}>Cancel</Button>*/}
                    {/*    </div>}*/}

                        { !!selectorDataType  &&
                            // {(selectorDataType !== null && selectorDataType !== undefined && selectorDataType !== "") &&
                            <div>
                                <FormHelperText id="Value_helper">leave this section blank if just the data point is
                                    enough for matching</FormHelperText>
                                <br/>
                                <DynamicCdpvValueField
                                    selectorDataPointId={selectorDataPointId}
                                    selectorValue={selectorSingleValue}
                                    selectorDataType={selectorDataType}
                                    selectorContext={"ContractSectionFilterSingleValue"}
                                    selectorLabel={"Exact Value"}
                                />
                                {(selectorDataType !== 'CODE' &&
                                        selectorDataType !== 'YES_NO' &&
                                        selectorDataType !== 'REFERENCE') &&
                                    <div>
                                        <br/>
                                        <br/>
                                        <FormHelperText id="Value_helper">- or -</FormHelperText>

                                        <br/>
                                        <Stack direction="row" spacing={4}>
                                            <DynamicCdpvValueField
                                                selectorDataPointId={selectorDataPointId}
                                                selectorValue={selectorFromValue}
                                                selectorDataType={selectorDataType}
                                                selectorContext={"ContractSectionFilterFromValue"}
                                                selectorLabel={"From Value"}
                                            />
                                            <DynamicCdpvValueField
                                                selectorDataPointId={selectorDataPointId}
                                                selectorValue={selectorToValue}
                                                selectorDataType={selectorDataType}
                                                selectorContext={"ContractSectionFilterToValue"}
                                                selectorLabel={"To Value"}
                                            />
                                        </Stack>
                                    </div>}
                                <br/>
                                <br/>
                                <Button
                                    type="submit"
                                >Submit</Button>
                                <Button onClick={() => closeContractSectionFilterDrawer()}>Cancel</Button>
                            </div>}
                    <HiddenFields/>

                    <br/>
                    <br/>
                    <br/>
                    {/*<p>{selectorDataPointId}</p>*/}
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
                <Input style={{ visibility: "hidden" }}
                       {...register('status', { required: false })}
                       id="status" name="status"  label="status" aria-describedby="status_entry"
                       defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.status)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('hierarchy', { required: false })}
                       id="hierarchy" name="hierarchy"  label="hierarchy" aria-describedby="hierarchy_entry"
                       defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.hierarchy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('createdBy', { required: false })}
                       id="createdBy" name="createdBy"  label="createdBy" aria-describedby="createdBy_entry"
                       defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.createdBy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedBy', { required: false })}
                       id="lastModifiedBy" name="lastModifiedBy"  label="lastModifiedBy" aria-describedby="lastModifiedBy_entry"
                       defaultValue=        {useSelector((state) => state.contractSectionFilterSlc.value.lastModifiedBy)}
                />
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorCsfDrawerState}
                initialState={{open: false}}
                onClose={closeContractSectionFilterDrawer}
            >
                {contractSectionFilterForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
